import React,{useEffect,useRef} from 'react'
import './projects.scss'
import GetProjectsImgs from './../../hooks/getProjects/getProjectsImg';
import Slide from './../slide/slide';
import { gsap, Power3 } from 'gsap';


const Projects = () => {

    const projects=GetProjectsImgs();
    const titleRef = useRef(null)
    useEffect(() => {
        gsap.from(titleRef.current, {
            duration: 1,
            x: '-300',
            opacity: 0,
            ease: Power3.easeIn,
            scrollTrigger: {
              trigger: titleRef.current,
              start: 'top 90%',
            },
          });

    }, [])



    return (
        <section id="projects" className="projects-container">
            <div className="container">
            <h2 ref={titleRef} className="projects-title no-select">PROJECTS</h2>
            <div className="projects-description">
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique incidunt impedit, at totam distinctio repellat?</p>
            </div>
            </div>
            <div className="project-list">
                {
                    projects.map((project,index)=>(

                        <Slide key={project.id} index={index} project={project}/>

                    ))
                }
            </div>
        </section>
    )
}

export default Projects
